module.exports = __webpack_public_path__ + "img/jianjie.5f18c48f.png";